import { render, staticRenderFns } from "./TabsVertical.vue?vue&type=template&id=7a6e243e"
import script from "./TabsVertical.vue?vue&type=script&lang=js"
export * from "./TabsVertical.vue?vue&type=script&lang=js"
import style0 from "./TabsVertical.vue?vue&type=style&index=0&id=7a6e243e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports